import { action } from 'satcheljs';

/**
 * Action which clears the guids and suggestions present
 * in the store
 * However zeroQuerySuggestions are not to be cleared for optimisations and caching purposes
 */
export default action('shallowClearSearchStore', function shallowClearSearchStore() {
    return {};
});
